  
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import api from "./api";
import { confirmAction, showAlert } from "./state/app";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'; 
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { createHead } from '@vueuse/head';
import "./assets/css/mh13-ui.css";


const app = createApp(App);
const head = createHead();

const backendUrl =
  process.env.VUE_APP_BACKEND_URL || "https://mh13.in/app/";

app.config.globalProperties.$api = api;
app.config.globalProperties.$alert = showAlert;
app.config.globalProperties.$confirm = confirmAction;
app.config.globalProperties.$server = backendUrl;
app.config.globalProperties.$hostname = backendUrl;
app.config.globalProperties.$asset_path = `${backendUrl}public/uploads/`;
 
app.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY || "",
    libraries: "places",
  },
});
app.use(VueSweetalert2);
app.use(head);
app.use(router).mount('#app');
